import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { useT } from "../i18n";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.matchMedia("(display-mode: fullscreen)").matches ||
  window.navigator.standalone === true;

const isIos = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const InstallButton = () => {
  const t = useT();
  const [prompt, setPrompt] = useState(() => window.__installPrompt || null);
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    const ready = () => setPrompt(window.__installPrompt);
    const done = () => setPrompt(null);
    window.addEventListener("installready", ready);
    window.addEventListener("appinstalled", done);
    return () => {
      window.removeEventListener("installready", ready);
      window.removeEventListener("appinstalled", done);
    };
  }, []);

  if (isStandalone() || (!prompt && !isIos())) return null;

  const install = async () => {
    if (!prompt) return setIosHelp((v) => !v);
    prompt.prompt();
    await prompt.userChoice;
    window.__installPrompt = null;
    setPrompt(null);
  };

  return (
    <>
      <button type="button" className="btn-ghost btn-icon" onClick={install} data-testid="install-app-button">
        <Download size={14} /> {t.install}
      </button>
      {iosHelp && (
        <p className="ios-help" data-testid="ios-install-help">
          {t.iosHelp[0]}<strong>{t.iosHelp[1]}</strong>{t.iosHelp[2]}<strong>{t.iosHelp[3]}</strong>{t.iosHelp[4]}
        </p>
      )}
    </>
  );
};
